export default __webpack_public_path__ + "static/media/claimsPageArrow.9fc31522.svg";